import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as modules from "../../../constants/modules";
import * as actions from "../../../actions/moduleActions";
import * as windowService from "../../../services/windowService";

class ServerPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedModule: null
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.module !== null && prevState.selectedModule === null) {
            return {
                selectedModule: nextProps.module
            };
        }

        return null;
    }

    handleModuleChange = (event) => {
        this.setState({
            selectedModule: event.target.value
        });
    };

    handleConfirmClick = () => {
        if (this.state.selectedModule !== null) {
            let result = windowService.setModule(this.state.selectedModule);

            if (result) {
                this.props.dispatchSaveModuleAction(this.state.selectedModule);
            }
        }
    };

    getConfirmButton = () => {
        if (this.state.selectedModule === null) {
            return (
                <button className="btn btn-info btn-md disabled">
                    <Translate value="general.confirm" />
                </button>
            );
        }

        return (
            <button className="btn btn-info btn-md" onClick={this.handleConfirmClick}>
                <Translate value="general.confirm" />
            </button>
        );
    };

    render() {
        return (
            <div className="select-server-window module-selection" style={{WebkitAppRegion: "no-drag"}}>
                <div className="col-xs-12 redlike-blue redlike-logo">
                    <div className="redlike-logo-all" />
                </div>
                <div className="col-xs-12 select-server-text">
                    <Translate value="welcome.selectModule" />
                </div>
                <div className="slim-scroll col-xs-12 server-table">
                    <table>
                        <thead>
                            <tr>
                                <th className="color-primary">
                                    <Translate value="general.nameTitle" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="server-row">
                                <td>
                                    <label className="radio-style light-style">
                                        <input
                                            type="radio"
                                            className="radio"
                                            name="module"
                                            value={modules.MODULE_FRONTDESK}
                                            checked={this.state.selectedModule === modules.MODULE_FRONTDESK}
                                            onChange={this.handleModuleChange}
                                        />
                                        <span className="checkmark" />
                                        Frontdesk
                                    </label>
                                </td>
                            </tr>
                            <tr className="server-row">
                                <td>
                                    <label className="radio-style light-style">
                                        <input
                                            type="radio"
                                            className="radio"
                                            name="module"
                                            value={modules.MODULE_MACHINE}
                                            checked={this.state.selectedModule === modules.MODULE_MACHINE}
                                            onChange={this.handleModuleChange}
                                        />
                                        <span className="checkmark" />
                                        Machine
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-xs-5" />
                <div className="col-xs-12 text-center">{this.getConfirmButton()}</div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        module: store.module.name
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSaveModuleAction: (module) => {
            dispatch(actions.saveModule(module));
        }
    };
};

export default ServerPanel = connect(mapStoreToProps, mapDispatchToProps)(ServerPanel);
